var map = {
	"./10_yellow.mp3": "c902",
	"./11_green.mp3": "bf8c6",
	"./12_purple.mp3": "2a75",
	"./13_pink.mp3": "3c41",
	"./14_orange.mp3": "13ad",
	"./1_hello.mp3": "2798",
	"./2_bye_bye.mp3": "650e",
	"./3_Tom.mp3": "1aaf",
	"./4_Lisa.mp3": "fe3d",
	"./5_rabbit.mp3": "2b51",
	"./6_bear.mp3": "2a3c",
	"./7_mole.mp3": "54c0",
	"./8_blue.mp3": "59d8",
	"./9_red.mp3": "df37"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e2e5";